import { render, staticRenderFns } from "./PropertyIntangibleAssetFieldset.vue?vue&type=template&id=4bb415d4&scoped=true"
import script from "./PropertyIntangibleAssetFieldset.vue?vue&type=script&lang=js"
export * from "./PropertyIntangibleAssetFieldset.vue?vue&type=script&lang=js"
import style0 from "./PropertyIntangibleAssetFieldset.vue?vue&type=style&index=0&id=4bb415d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb415d4",
  null
  
)

export default component.exports